import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 475062F1-407D-43B6-8FBF-1E0D4C7D690C
 * name tie
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tie.svg
 * tags
 * - Clothing 
 */
export const TieIcon = createSvgIcon(<><path d="M6,2L10,6L7,17L12,22L17,17L14,6L18,2Z" /></>, 'TieIcon');
export default TieIcon